import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { PrimeNG } from 'primeng/config';
import * as AuthActions from './store/auth/actions/auth.actions';
import { WaitComponent } from './components/wait-component/wait.component';
import { NotificationToastComponent } from './components/notification-toast/notification-toast.component';
import { RouterLoadingService } from './service/router-loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, WaitComponent, NotificationToastComponent],
  templateUrl: './app.html',
})
export class App implements OnInit {
  private primeng = inject(PrimeNG);
  private store = inject(Store);
  private routerLoadingService = inject(RouterLoadingService);

  ngOnInit(): void {
    this.primeng.ripple.set(true);
    this.store.dispatch(AuthActions.checkAuth());
  }
}
